import { mapGetters } from "vuex";

import {
  getLabel,
  sortAlphabetically,
  validateHasValue,
} from "@/lib/componentUtil";

import { getFkOptionList } from "@/lib/resolver";

export default {
  computed: {
    optionEntityListFormatted() {
      const { optionEntityList } = this;

      return optionEntityList
        .map(entity => getLabel(entity))
        .sort(sortAlphabetically);
    },
    optionEntityAttributeList() {
      const {
        attribute: { fkName, name: attributeName },
      } = this;

      if (!fkName) {
        throw new Error(
          `listfilterAdvanced/SelectFk.vue requires fkName to be defined on ${attributeName} `
        );
      }

      return this.attributeFilter({ entityName: fkName });
    },
    ...mapGetters({
      attributeFilter: "attribute/filter",
    }),
  },
  async created() {
    const { attribute } = this;

    const { elementType, fkExists, fkName, name } = attribute;

    if (!fkExists) {
      throw new Error(
        `listfilterAdvanced/SelectFk.vue cannot render options for ${name} (${elementType}) because it doesn't have fkExists set to true`
      );
    }

    if (!fkName) {
      throw new Error(
        `listfilterAdvanced/SelectFk.vue cannot render options for ${name} (${elementType}) because it doesn't have a fkName specified`
      );
    }

    this.loading = true;

    let optionEntityList;
    try {
      optionEntityList = await getFkOptionList(attribute);
    } catch (e) {
      console.error(
        `Error in listfilterAdvanced/SelectFk.vue created hook resolving optionEntityList`
      );

      this.loading = false;
      throw e;
    }

    this.optionEntityList = optionEntityList;
    this.loading = false;
  },
  data() {
    return {
      optionEntityList: [],
    };
  },
  methods: {
    validateHasValue,
  },
  props: {
    attribute: {
      required: true,
      type: Object,
    },
    value: {},
  },
};
